export enum StickyZoneMenuId {
  FontSize = 'FontSize',
  ThemeColor = 'ThemeColor',
  TextAlign = 'TextAlign',
  ZoneShape = 'ZoneShape',
  ZoneTitlePosition = 'ZoneTitlePosition',
  HyperLink = 'HyperLink',
  ZoneDescription = 'ZoneDescription',
  Grouping = 'Grouping',
  ConvertToView = 'ConvertToView',
  DeleteZone = 'DeleteZone',
}
